import axios from 'axios';
import {
  ReceiveTeihoReceptionType,
  ReceiveEventReceptionType,
  NavigateState,
} from '../types/teikihoan/commonDefinition';

/**
 * APIリクエスト用クライアント
 */
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * うぇぶひだまりAPIリクエスト用クライアント
 */
const axiosWHClient = axios.create({
  baseURL: process.env.REACT_APP_WEB_HIDAMARI_LOGIN_API,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

/**
 * APIリクエスト用クライアント（認証付き）
 * @param token
 * @returns
 */
const axiosClientWithAuth = (token: string) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${token}`, // トークンを動的に設定
      'Access-Control-Expose-Headers': 'Authorization',
    },
  });
};

/**
 * メンテナンス中判定
 * @returns
 */
export const getMainte = async () => {
  try {
    const json = JSON.stringify({});
    const url = 'maintenance';

    const res = await axiosClient.post(url, json);

    return res.data;
  } catch (e) {
    throw e;
  }
};

/**
 * Comcube疎通確認
 * @returns
 */
export const checkHeartbeat = async (data: { judgement_no: string }) => {
  try {
    const json = JSON.stringify(data);
    const url = 'heartbeat';

    const res = await axiosClient.post(url, json);

    return res.data;
  } catch (e) {
    throw e;
  }
};

/**
 * CSRFトークン取得
 * @returns
 */
export const getCSRFToken = async () => {
  try {
    let token = '';
    const res = await axiosClient
      .post('generate-csrf-token', JSON.stringify({}))
      .then((response) => {
        token = response.headers['authorization'];
        return response;
      });

    return { result: res.data.result, page_token: token };
  } catch (e) {
    throw e;
  }
};

/**
 * 定期保安メール送信
 * @param data
 * @returns
 */
export const sendMailToTeikihoanURL = async (data: {
  mail_address: string;
  last_name: string;
  first_name: string;
  source_cd: string;
}) => {
  try {
    const res = await axiosClient.post('system/sendmail', JSON.stringify(data));
    return res.data;
  } catch (e) {
    throw e;
  }
};

//#region 予約種別一覧取得
/**
 * 予約種別一覧取得
 * @returns
 */
export const GetYoyakuSbtList = async () => {
  try {
    const res = await axiosClient.post(
      'confirm/yoyaku-sbt',
      JSON.stringify({})
    );
    return res.data;
  } catch (e) {
    throw e;
  }
};
//#endregion

//#region 予約情報取得
/**
 * 予約情報取得
 * @param data
 * @returns
 */
export const getYoyakuInfo = async (data: {
  uketsuke_no: string;
  yoyaku_sbt_cd: string;
  guid?: string; //2024.09 COMTEC kawaji ADD
}) => {
  try {
    const json = JSON.stringify(data);
    const url = 'confirm/yoyaku-info';

    const res = await axiosClientWithAuthPost(url, json);
    return res.data;
  } catch (e) {
    throw e;
  }
};
//#endregion

//#region 予約キャンセル処理
/**
 * 予約キャンセル処理
 * @param data
 * @returns
 */
export const cancelYoyaku = async (
  uketsuke_no: string,
  yoyaku_sbt_cd: string,
  //2024.09 COMTEC kawaji MOD START
  // data: ReceiveTeihoReceptionType | null,
  // eData?: ReceiveEventReceptionType | null
  transition_source: string,
  token: string
  //2024.09 COMTEC kawaji MOD END
) => {
  try {
    const param = {
      uketsuke_no: uketsuke_no,
      yoyaku_sbt_cd: yoyaku_sbt_cd,
      //2024.09 COMTEC kawaji MOD START
      //teikihoan_reception_request: data,
      //event_reception_request: eData,
      transition_source: transition_source,
      token: token,
      //2024.09 COMTEC kawaji MOD END
    };
    const json = JSON.stringify(param);
    const url = 'confirm/yoyaku-cancel';

    const res = await axiosClientWithAuthPost(url, json);
    return res.data;
  } catch (e) {
    throw e;
  }
};
//#endregion

//#region 他システム起動
/**
 * 他システム起動
 * @param data
 * @returns
 */
export const openSystem = async (param: NavigateState) => {
  try {
    const json = JSON.stringify(param);
    const url = 'system/get';

    const res = await axiosClientWithAuthPost(url, json);

    return res.data;
  } catch (e) {
    throw e;
  }
};
//#endregion

//#region 共通
/**
 * APIリクエスト送信（CSRF対策版）
 * @param url
 * @param json
 * @returns
 */
const axiosClientWithAuthPost = async (url: string, json: string) => {
  try {
    // JWT取得(CSRF対策用)
    const resToken = await getCSRFToken();
    if (resToken.result !== 0) throw new Error('CSRFトークン取得エラー');
    var csrfToken = resToken.page_token;
    // JWtをヘッダーに設定,request送信
    const client = axiosClientWithAuth(csrfToken);
    const res = await client.post(url, json);

    return res;
  } catch (e) {
    throw e;
  }
};

//#endregion

//2024.09 COMTEC kawaji ADD START

/****************************************
 * お客様情報連携用の予約システム情報を登録
 * @param data  パラメータ
 * @param token ページ認証トークン
 ****************************************/
export const setSysForWH = async (param: {
  transition_source: string;
  token: string;
  event_sbt_cd: string;
  step: number;
  from_page: string;
}) => {
  try {
    const json = JSON.stringify(param);
    const url = 'sys_wh';

    // リクエスト送信
    const res = await axiosClient.post(url, json);

    return res.data;
  } catch (e) {
    throw e;
  }
};

//2024.09 COMTEC kawaji ADD END
